export default "__VITE_ASSET__DY5Q6Ei___"